import { createContext, PropsWithChildren, useContext } from 'react';
/**
 * Mock your flag here (flags must not be camelCase)
 * eg. { 'random-flag': true }
 *
 * Some default flags are turned to true
 */
const MOCK_FLAGS = {
  'climate_client-feature': true,
  'scenarios_client-feature': true,
  'monitoring_client-feature': true,
  'monitoring_create-edit-alert-rule': true,
  'calc_internal-feature': true,
  'explainability_internal-feature': true,
  'monitoring_replace-score-with-vr-subrating': true,
  'borrower-spread-audit': true,
  'monitoring_wayfinder-page': true,
  'scenarios_show-processing-banner': true,
  'audit_excluded-borrowers': true,
  'climate-scorecard_client-feature': true,
  'loanbook-analysis_client-feature': true,
  'monitoring_view-all-scenarios': true,
  'monitoring_has-stress-scenarios': true,
};

const mockFlagsContext = createContext<Record<string, unknown>>(MOCK_FLAGS);

export function useMockUseFlags(): Record<string, unknown> {
  return useContext(mockFlagsContext);
}

export function MockFeatureFlagsProvider({ children, flags }: PropsWithChildren<{ flags?: Record<string, unknown> }>) {
  return <mockFlagsContext.Provider value={{ ...MOCK_FLAGS, ...flags }}>{children}</mockFlagsContext.Provider>;
}
